import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "insta-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"page-header\"><div class=\"title\">언팔 찾기</div><div class=\"subtitle\">내가 팔로우하지만 나를 팔로우하지 않는 계정을 찾아드려요</div></div><div class=\"privacy-banner\"><span class=\"pb-ic\">🔒</span><span class=\"pb-text\"> 업로드한 파일은 <b>서버로 전송되지 않고</b> 브라우저 안에서만 분석됩니다. 저장·수집도 하지 않아요. </span></div>", 2)
const _hoisted_4 = { class: "upload-section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "upload-header" }, "맞팔 아닌 팔로잉 찾기", -1)
const _hoisted_6 = {
  key: 0,
  class: "prep-steps"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"prep-step\"><span class=\"ps-num\">1</span><span class=\"ps-text\"><a href=\"https://www.instagram.com/download/request/\" target=\"_blank\" rel=\"noopener noreferrer\">인스타그램 데이터 다운로드 →</a> 에서 <b>JSON 형식</b>으로 정보 요청 </span></div><div class=\"prep-step\"><span class=\"ps-num\">2</span><span class=\"ps-text\">메일로 받은 <b>ZIP 파일</b>을 다운로드 (요청 후 몇 분~몇 시간 소요)</span></div><div class=\"prep-step\"><span class=\"ps-num\">3</span><span class=\"ps-text\">ZIP을 그대로 아래에 올리면 끝 — 압축 풀 필요 없어요</span></div>", 3)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "drop-zone-icon" }, "📁", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "drop-zone-text" }, " Instagram 데이터 ZIP 파일을 여기에 드래그하세요 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "drop-zone-sub" }, "또는", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "file-select-btn",
  for: "zip-upload"
}, "파일 선택", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "drop-zone-hint" }, "ZIP 또는 JSON 파일 지원", -1)
const _hoisted_15 = {
  key: 1,
  class: "loading-area"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "파일을 분석하고 있습니다...", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "error-message"
}
const _hoisted_20 = { class: "json-fallback" }
const _hoisted_21 = {
  key: 0,
  class: "json-fallback-content"
}
const _hoisted_22 = { class: "json-file-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "file-upload1",
  class: "json-file-btn"
}, "followers 파일", -1)
const _hoisted_24 = { class: "json-file-name" }
const _hoisted_25 = { class: "json-file-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "file-upload2",
  class: "json-file-btn"
}, "following 파일", -1)
const _hoisted_27 = { class: "json-file-name" }
const _hoisted_28 = {
  key: 0,
  class: "result-section"
}
const _hoisted_29 = { class: "summary-cards" }
const _hoisted_30 = { class: "summary-count" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "맞팔 안한 사람", -1)
const _hoisted_32 = { class: "summary-count" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "맞팔", -1)
const _hoisted_34 = { class: "summary-count" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "summary-label" }, "팔로워만", -1)
const _hoisted_36 = { class: "toolbar" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "name-asc" }, "이름 오름차순", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "name-desc" }, "이름 내림차순", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "date-asc" }, "날짜 오래된 순", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "date-desc" }, "날짜 최신 순", -1)
const _hoisted_41 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "user-list" }
const _hoisted_43 = { class: "user-list-header" }
const _hoisted_44 = { class: "user-card-main" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "user-card-sub" }
const _hoisted_48 = { class: "follow-date" }
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  key: 0,
  class: "load-more-row"
}
const _hoisted_51 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_52 = { class: "reset-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (!_ctx.hasResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_router_link, {
              to: "/insta/home",
              class: "prep-more"
            }, {
              default: _withCtx(() => [
                _createTextVNode("자세한 그림 가이드 보기 →")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["drop-zone", { 'drag-over': _ctx.isDragOver }]),
        onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
        onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isDragOver = false), ["prevent"])),
        onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
      }, [
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("input", {
          type: "file",
          id: "zip-upload",
          accept: ".zip",
          class: "file-input-hidden",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleZipUpload && _ctx.handleZipUpload(...args)))
        }, null, 32),
        _hoisted_14
      ], 34),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: "json-fallback-toggle",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showJsonUpload = !_ctx.showJsonUpload))
        }, _toDisplayString(_ctx.showJsonUpload ? "▲" : "▼") + " JSON 파일로 직접 업로드 ", 1),
        (_ctx.showJsonUpload)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("input", {
                  type: "file",
                  id: "file-upload1",
                  accept: ".json",
                  class: "file-input-hidden",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload1 && _ctx.handleFileUpload1(...args)))
                }, null, 32),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.fileName1), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("input", {
                  type: "file",
                  id: "file-upload2",
                  accept: ".json",
                  class: "file-input-hidden",
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload2 && _ctx.handleFileUpload2(...args)))
                }, null, 32),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.fileName2), 1)
              ]),
              _createElementVNode("div", {
                class: "json-analyze-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getResult()))
              }, "결과보기")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.hasResult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              class: _normalizeClass(["summary-card", { active: _ctx.activeTab === 'unfollowers' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTab = 'unfollowers'))
            }, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.unfollowers.length), 1),
              _hoisted_31
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["summary-card", { active: _ctx.activeTab === 'mutuals' }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeTab = 'mutuals'))
            }, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.mutuals.length), 1),
              _hoisted_33
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["summary-card", { active: _ctx.activeTab === 'onlyFollowers' }]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeTab = 'onlyFollowers'))
            }, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.onlyFollowers.length), 1),
              _hoisted_35
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "search-input",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: "사용자 검색..."
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "sort-select",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.sortOption) = $event))
            }, _hoisted_41, 512), [
              [_vModelSelect, _ctx.sortOption]
            ]),
            _createElementVNode("button", {
              class: "tool-btn",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleExportCSV && _ctx.handleExportCSV(...args))),
              title: "CSV 내보내기"
            }, " CSV "),
            _createElementVNode("button", {
              class: "tool-btn",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleCopyUsernames && _ctx.handleCopyUsernames(...args))),
              title: "사용자명 복사"
            }, _toDisplayString(_ctx.copyLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.tabTitle) + " (" + _toDisplayString(_ctx.filteredUsers.length) + "명) ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleUsers, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "user-card",
                key: user.value
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", {
                    class: "user-name",
                    onClick: ($event: any) => (_ctx.openLink(user.href))
                  }, _toDisplayString(user.value), 9, _hoisted_45),
                  _createElementVNode("button", {
                    class: "copy-single-btn",
                    onClick: _withModifiers(($event: any) => (_ctx.copySingle(user.value)), ["stop"]),
                    title: "사용자명 복사"
                  }, " 복사 ", 8, _hoisted_46)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.getDateFormatByTimestamp(user.timestamp, "yyyy년 MM월 dd일")), 1),
                  _createElementVNode("a", {
                    class: "profile-link",
                    href: user.href,
                    target: "_blank",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                  }, "프로필", 8, _hoisted_49)
                ])
              ]))
            }), 128)),
            (_ctx.filteredUsers.length > _ctx.visibleCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("button", {
                    class: "load-more-btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.visibleCount += _ctx.PAGE_SIZE))
                  }, " 더 보기 (" + _toDisplayString(_ctx.visibleUsers.length) + "/" + _toDisplayString(_ctx.filteredUsers.length) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.filteredUsers.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, " 검색 결과가 없습니다. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("button", {
              class: "reset-btn",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetAll && _ctx.resetAll(...args)))
            }, "다른 파일로 다시 분석")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}